import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

export default function News() {
    const [items, setItems] = useState([]);
    useEffect(() => { api.get("/news").then((r) => setItems(r.data)); }, []);

    return (
        <div data-testid="news-page" className="grain">
            <section className="border-b border-line py-16 md:py-24 bg-bg-soft">
                <div className="max-w-7xl mx-auto px-5 md:px-10">
                    <div className="text-gold text-xs tracking-[0.4em] uppercase font-bold mb-4">The Word</div>
                    <h1 className="h-display text-6xl md:text-8xl">News</h1>
                </div>
            </section>
            <section className="max-w-7xl mx-auto px-5 md:px-10 py-16">
                <div className="grid md:grid-cols-3 gap-5">
                    {items.map((n, i) => (
                        <Link key={n.id} to={`/news/${n.slug}`} className="card-flat overflow-hidden group" data-testid={`news-card-${i}`}>
                            <div className="aspect-video bg-cover bg-center transition-transform group-hover:scale-105" style={{ backgroundImage: `url('${n.cover_image || ""}')` }} />
                            <div className="p-5">
                                <div className="text-[10px] tracking-[0.3em] uppercase text-gold mb-2">
                                    {new Date(n.published_at || n.created_at).toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" })}
                                </div>
                                <div className="h-display text-xl leading-tight group-hover:text-gold transition-colors">{n.title}</div>
                                {n.excerpt && <p className="text-ink text-sm mt-3 leading-relaxed line-clamp-3">{n.excerpt}</p>}
                            </div>
                        </Link>
                    ))}
                </div>
                {items.length === 0 && <div className="text-center text-ink py-20">No news yet.</div>}
            </section>
        </div>
    );
}
